import { __generator } from "tslib";
import { delay } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { scrollTo, showOverlay, showScreen } from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import { areTimersEnabled } from '../selectors/timer';
export default function screenTimer() {
    var TYPE_ANCHOR;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                TYPE_ANCHOR = 6;
                return [4 /*yield*/, takeLatest(actionTypes.SCREEN_TIMER, function (_a) {
                        var previousScrollPos, scrollPos;
                        var timer = _a.timer;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!timer) return [3 /*break*/, 8];
                                    return [4 /*yield*/, call(delay, timer.ms)];
                                case 1:
                                    _b.sent();
                                    return [4 /*yield*/, select(areTimersEnabled)];
                                case 2:
                                    if (!_b.sent()) return [3 /*break*/, 8];
                                    if (!(timer.type === TYPE_ANCHOR)) return [3 /*break*/, 4];
                                    return [4 /*yield*/, put(scrollTo(timer.anchorYPos, timer.smoothScroll))];
                                case 3:
                                    _b.sent();
                                    return [3 /*break*/, 8];
                                case 4:
                                    if (!timer.isOverlay) return [3 /*break*/, 6];
                                    return [4 /*yield*/, put(showOverlay(timer.id))];
                                case 5:
                                    _b.sent();
                                    return [3 /*break*/, 8];
                                case 6:
                                    previousScrollPos = document.getElementById('currentScreen').scrollTop;
                                    scrollPos = {
                                        previous: previousScrollPos,
                                        current: timer.maintainScroll ? previousScrollPos : 0,
                                    };
                                    return [4 /*yield*/, put(showScreen(timer.destScreenID, timer.transition, scrollPos, {
                                            timer: timer,
                                        }))];
                                case 7:
                                    _b.sent();
                                    _b.label = 8;
                                case 8: return [2 /*return*/];
                            }
                        });
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
